import type { BeachSectionFragment } from '@data-access/lib/gql/beach-chairs/documents'
import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents'
import type { HeroImage } from '@shared/utils/hero-image'
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation'
import type { RentableShopFragment } from 'src/lib/backend/documents/rentables'

import type { ToggleWishlistItemProps } from './lib/wishlist-toggle'

type Product =
  | NexperienceFragment
  | AccommodationFragment
  | BeachSectionFragment
  | RentableShopFragment

export function mapWishlistProduct(
  product: Product,
  images: HeroImage[]
): ToggleWishlistItemProps | null {
  switch (product.__typename) {
    case 'Accommodation':
      return {
        productId: product.id.toString(),
        publicProductId: product.id,
        productType: 'accommodation',
        productName: product.name,
        locationName: product.city,
        image: images?.[0]?.url,
        origin: 'pdp',
      }
    case 'Nexperience':
      return {
        productId: product.id,
        publicProductId: product.publicId,
        productType: 'experience',
        productName: product.title,
        locationName: product.location?.city,
        image: images?.[0]?.url,
        origin: 'pdp',
      }
    case 'BeachSection':
      return {
        productId: product.id.toString(),
        publicProductId: product.id,
        productType: 'beach_chair',
        productName: product.name,
        locationName: product.location?.city,
        image: images?.[0]?.url,
        origin: 'pdp',
      }
    case 'RentableShop':
      return {
        productId: product.id.toString(),
        publicProductId: product.id,
        productType: 'bike',
        productName: product.name,
        locationName: product.city,
        image: product.images?.[0]?.url,
        origin: 'pdp',
      }
    default:
      return null
  }
}
